import { createElement } from "../../helpers"

class ClampContent extends HTMLElement {
  // Without scroll-driven animations (Firefox), CSS can't tell whether the content overflows.
  static #overflowObserver = CSS.supports("animation-timeline: scroll()")
    ? null
    : new ResizeObserver((entries) => {
        const overflowing = entries.map(({ target }) => target.scrollHeight > target.clientHeight)
        entries.forEach(({ target }, index) =>
          target.parentElement.classList.toggle("--overflowing", overflowing[index])
        )
      })

  connectedCallback() {
    this.button ??= createElement("button", {
      type: "button",
      className: "btn --text-muted --sm --outline",
      textContent: this.getAttribute("label") || "Expand",
      onclick: () => this.classList.add("--disabled"),
    })
    this.append(this.button)
    ClampContent.#overflowObserver?.observe(this.firstElementChild)
  }

  disconnectedCallback() {
    ClampContent.#overflowObserver?.unobserve(this.firstElementChild)
  }
}

window.customElements.define("clamp-content", ClampContent)
